import React from 'react';

import Modal from '~/components/modals/modal';

import styles from '~/components/modals/pest-type/pest-type-modal.module.scss';

const PestTypeModal = ({ onClose, isOpen }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <Content />
    </Modal>
  );
};

const Content = () => (
  <div className={styles.pestTypeModal}>
    <p className={styles.pestTypeModalHeader}>
      Get rid of dozens of <br />
      household pests quickly
    </p>
    <div className={styles.pestModalBody}>
      <div className={styles.pestContainer}>
        <div className={styles.imageWrapper}>
          <img
            alt="Mosquito"
            src="/images/pest-funnel/pest-concern-mosquito.jpg"
          />
        </div>
        <div className={styles.copyWrapper}>
          <p>Flying bugs</p>
          <ul>
            <li>Mosquitos</li>
            <li>Gnats</li>
          </ul>
        </div>
      </div>
      <div className={styles.pestContainer}>
        <div className={styles.imageWrapper}>
          <img alt="Spider" src="/images/pest-funnel/modal-biting.jpg" />
        </div>
        <div className={styles.copyWrapper}>
          <p>Biting bugs</p>
          <ul>
            <li>Mosquitos</li>
            <li>Fleas</li>
            <li>Ticks</li>
          </ul>
        </div>
      </div>
      <div className={styles.pestContainer}>
        <div className={styles.imageWrapper}>
          <img alt="Ant" src="/images/pest-funnel/modal-crawling.jpg" />
        </div>
        <div className={styles.copyWrapper}>
          <p>Crawling bugs</p>
          <ul>
            <li>American cockroaches</li>
            <li>
              Ants (except fire ants, harvester ants, Pharaoh ants, and
              carpenter ants)
            </li>
            <li>Bed bugs</li>
            <li>Beetles (multiple types)</li>
            <li>Centipedes</li>
            <li>Crickets</li>
            <li>Cutworms</li>
            <li>Earwigs</li>
            <li>Millipedes</li>
            <li>Pillbugs</li>
            <li>Roaches</li>
            <li>Silverfish</li>
            <li>Sowbugs</li>
            <li>
              Spiders (excluding black widow, brown recluse, and hobo spiders)
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default PestTypeModal;
